export default __webpack_public_path__ + "static/media/triangle-down.cd5adcb6.svg";